import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/list.svg` */
export const ListIcon = createTripletGlyphIcon('ListIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.89551 11.167C3.35561 11.1672 3.72949 11.5399 3.72949 12C3.72933 12.46 3.3555 12.8328 2.89551 12.833C2.43552 12.8328 2.06266 12.46 2.0625 12C2.0625 11.5399 2.43542 11.1672 2.89551 11.167Z"
        fill="currentColor"
      />
      <path
        d="M13.3887 11.4502C13.6922 11.4505 13.9385 11.6964 13.9385 12C13.9383 12.3034 13.6921 12.5495 13.3887 12.5498H5.48828C5.18472 12.5497 4.93864 12.3036 4.93848 12C4.93848 11.6963 5.18461 11.4503 5.48828 11.4502H13.3887Z"
        fill="currentColor"
      />
      <path
        d="M2.89551 7.16797C3.35561 7.16813 3.72949 7.54084 3.72949 8.00098C3.72949 8.46111 3.35561 8.83382 2.89551 8.83398C2.43542 8.83381 2.0625 8.46111 2.0625 8.00098C2.0625 7.54085 2.43542 7.16814 2.89551 7.16797Z"
        fill="currentColor"
      />
      <path
        d="M13.3887 7.4502C13.6922 7.45047 13.9385 7.69641 13.9385 8C13.9385 8.30359 13.6922 8.54953 13.3887 8.5498H5.48828C5.18461 8.5497 4.93848 8.30369 4.93848 8C4.93848 7.69631 5.18461 7.4503 5.48828 7.4502H13.3887Z"
        fill="currentColor"
      />
      <path
        d="M2.89551 3.16895C3.3555 3.16911 3.72933 3.54196 3.72949 4.00195C3.72949 4.46209 3.35561 4.8348 2.89551 4.83496C2.43542 4.83478 2.0625 4.46208 2.0625 4.00195C2.06266 3.54196 2.43552 3.16912 2.89551 3.16895Z"
        fill="currentColor"
      />
      <path
        d="M13.3887 3.45215C13.6921 3.45242 13.9383 3.6985 13.9385 4.00195C13.9385 4.30554 13.6922 4.55149 13.3887 4.55176H5.48828C5.18461 4.55165 4.93848 4.30564 4.93848 4.00195C4.93864 3.6984 5.18472 3.45225 5.48828 3.45215H13.3887Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.25781 12.5625C3.77541 12.5627 4.19531 12.9824 4.19531 13.5C4.19514 14.0175 3.7753 14.4373 3.25781 14.4375C2.74015 14.4375 2.32049 14.0176 2.32031 13.5C2.32031 12.9822 2.74005 12.5625 3.25781 12.5625Z"
        fill="currentColor"
      />
      <path
        d="M15.1309 12.9502C15.4344 12.9505 15.6807 13.1964 15.6807 13.5C15.6807 13.8036 15.4344 14.0495 15.1309 14.0498H6.10547C5.8018 14.0497 5.55566 13.8037 5.55566 13.5C5.55566 13.1963 5.8018 12.9503 6.10547 12.9502H15.1309Z"
        fill="currentColor"
      />
      <path
        d="M3.25781 8.06445C3.77541 8.06465 4.19531 8.48431 4.19531 9.00195C4.19487 9.51922 3.77514 9.93926 3.25781 9.93945C2.74032 9.93945 2.32075 9.51935 2.32031 9.00195C2.32031 8.48419 2.74005 8.06445 3.25781 8.06445Z"
        fill="currentColor"
      />
      <path
        d="M15.1309 8.45215C15.4344 8.45245 15.6807 8.69838 15.6807 9.00195C15.6804 9.3053 15.4342 9.55146 15.1309 9.55176H6.10547C5.80196 9.55165 5.55593 9.30542 5.55566 9.00195C5.55566 8.69826 5.8018 8.45225 6.10547 8.45215H15.1309Z"
        fill="currentColor"
      />
      <path
        d="M3.25781 3.56543C3.77541 3.56563 4.19531 3.98528 4.19531 4.50293C4.19514 5.02043 3.7753 5.44023 3.25781 5.44043C2.74015 5.44043 2.32049 5.02055 2.32031 4.50293C2.32031 3.98516 2.74005 3.56543 3.25781 3.56543Z"
        fill="currentColor"
      />
      <path
        d="M15.1309 3.95312C15.4344 3.95343 15.6807 4.19936 15.6807 4.50293C15.6807 4.8065 15.4344 5.05243 15.1309 5.05273H6.10547C5.8018 5.05263 5.55566 4.80662 5.55566 4.50293C5.55566 4.19924 5.8018 3.95323 6.10547 3.95312H15.1309Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.34326 17.3662C4.69304 17.3662 4.97705 17.6503 4.97705 18C4.97684 18.3498 4.6927 18.6328 4.34326 18.6328C3.99382 18.6328 3.70968 18.3498 3.70947 18C3.70947 17.6503 3.99348 17.3662 4.34326 17.3662ZM8.15674 17.8662H20.1567C20.2304 17.8662 20.2905 17.9264 20.2905 18C20.2903 18.0738 20.2299 18.1328 20.1567 18.1328H8.15674C8.0834 18.1327 8.02314 18.0735 8.02295 18C8.02295 17.9267 8.08295 17.8664 8.15674 17.8662ZM4.34326 11.3682C4.69304 11.3682 4.97705 11.6522 4.97705 12.002C4.97684 12.3518 4.6927 12.6348 4.34326 12.6348C3.99382 12.6348 3.70968 12.3518 3.70947 12.002C3.70947 11.6522 3.99348 11.3682 4.34326 11.3682ZM8.15674 11.8682H20.1567C20.2304 11.8682 20.2905 11.9283 20.2905 12.002C20.2903 12.0758 20.2299 12.1348 20.1567 12.1348H8.15674C8.0834 12.1347 8.02314 12.0754 8.02295 12.002C8.02295 11.9287 8.08295 11.8683 8.15674 11.8682ZM4.34326 5.37015C4.69304 5.37015 4.97705 5.65416 4.97705 6.00394L4.96338 6.13187C4.90406 6.42033 4.64893 6.63773 4.34326 6.63773C3.9938 6.63773 3.70965 6.35377 3.70947 6.00394L3.72314 5.87601C3.77385 5.62892 3.96824 5.43453 4.21533 5.38382L4.34326 5.37015ZM8.15674 5.87015H20.1567C20.2304 5.87015 20.2905 5.9303 20.2905 6.00394L20.2798 6.05569C20.2595 6.10374 20.2118 6.13773 20.1567 6.13773H8.15674C8.08338 6.1376 8.02311 6.07742 8.02295 6.00394L8.03369 5.95218C8.05389 5.90438 8.10138 5.87024 8.15674 5.87015Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.23333"
      />
    </svg>
  ),
});
